function ragFilter() {
    'ngInject';

    return function (value, v1, v2) {
        if (value <= v1) {
            return 'red';
        } else if (value <= v2) {
            return 'amber';
        } else {
            return 'green';
        }
    };
}

angular
    .module('BB')
    .filter('rag', ragFilter);


// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/_filters/rag.filter.js